import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { convertMillisToHoursMinutes } from 'src/app/@core/utils/convertMillisToHoursMinutes.functions';
import {
  DatatableColumn,
  DatatableColumnType,
  SearchControl,
  SearchControlType,
  StringMap,
} from 'src/app/@theme/datatable/datatable.component';
import { RankListResponseWrapper } from 'src/app/api/models';

export interface ResponsiveRoomChampionsRow {
  level: string;
  month?: string;
  data: {
    picture: string;
    teamName: string;
    time: string;
    timeAverage: string;
  };
}

@Component({
  selector: 'app-responsiveroomchampions',
  templateUrl: './responsiveroomchampions.component.html',
  styleUrls: ['./responsiveroomchampions.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ResponsiveRoomchampionsComponent {
  roomChampions: RankListResponseWrapper[] = [];
  roomChampionRows: ResponsiveRoomChampionsRow[] = [];
  searchControlSettings: SearchControl[] = [];
  searchable: boolean = false;
  currentMonth: string = '';
  levels = ['EASY', 'MEDIUM', 'HARD', 'X_HARD'];
  defaultMonth: string = '';
  headerHeight: number = 0;

  @Input() loading: boolean = false;
  @Input() theme: string = '';
  @Input() filters: StringMap | undefined;
  @Input() month: string = '';

  columns: DatatableColumn[] = [
    { prop: 'level', name: '', width: 200, sortable: false },
    {
      prop: 'data',
      name: '',
      sortable: false,
      width: 600,
      type: DatatableColumnType.ARRAY,
    },
  ];

  private buildSearchControlSettings(): void {
    if (!this.roomChampions) {
      return;
    }

    const today = new Date();
    const originalToday = new Date(today);
    const months: StringMap = {};

    for (let i = 0; i < 4; i++) {
      const dateKey =
        today.getFullYear() +
        '.' +
        String(today.getMonth() + 1).padStart(2, '0') +
        '.';

      this.defaultMonth =
        originalToday.getFullYear() +
        '.' +
        String(originalToday.getMonth() + 1).padStart(2, '0') +
        '.';
      const dateValue =
        today.getFullYear().toString() +
        '.' +
        (today.getMonth() + 1).toString().padStart(2, '0') +
        '.';

      months[dateKey] = dateValue;
      today.setMonth(today.getMonth() - 1);
    }

    this.defaultMonth =
      originalToday.getFullYear() +
      '.' +
      String(originalToday.getMonth() + 1).padStart(2, '0') +
      '.';

    this.searchControlSettings = [
      {
        title: 'Month',
        type: SearchControlType.SELECT,
        property: 'month',
        bindToColumn: 'rank',
        options: months,
        defaultValue: this.defaultMonth,
      },
    ];
  }

  @Input('roomChampions') set setRoomChampions(roomChampions: any[]) {
    this.roomChampions = roomChampions;
    this.buildSearchControlSettings();
    this.mapRoomChampionRows();
  }

  @HostBinding('class.light-theme') get isLightTheme() {
    return this.theme === 'light';
  }
  @HostBinding('class.dark-theme') get isDarkTheme() {
    return this.theme === 'dark';
  }

  private mapRoomChampionRows(): void {
    if (!this.roomChampions || this.roomChampions.length === 0) {
      this.roomChampionRows = [];
      return;
    }

    const roomChampionsData = this.roomChampions.filter(
      (champion) => champion && Array.isArray(champion.data) && champion.data.length > 0,
    );
    const allEntries = roomChampionsData.flatMap((champion) => champion.data as any[]);
    const currentMonthEntries = allEntries.filter((entry: any) => entry.month === this.month);
    if (!currentMonthEntries || currentMonthEntries.length === 0) {
      this.roomChampionRows = [];
      return;
    }


    const result: ResponsiveRoomChampionsRow[] = [];

    this.levels.forEach((level) => {
      const teams = currentMonthEntries.find(
        (entry: any) => entry.level === level,
      );

      if (teams) {
        const time = convertMillisToHoursMinutes(teams.time!.toString());
        const averageGameTime = convertMillisToHoursMinutes(
          teams.averageGameTime!.toString(),
        );

        result.push({
          level: level,
          month: teams.month,
          data: {
            picture: teams.picture || '../../../../assets/noteampicture.png',
            teamName: teams.teamName || 'Unknown Team',
            time,
            timeAverage: 'all games avg: ' + averageGameTime,
          },
        });
      }
    });

    this.roomChampionRows = result;
  }

  onFilterChange(event: any): void {
    console.log('event', event);
    this.month = event.month;
    this.mapRoomChampionRows();
  }
}
